import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "reduxStore/state";
import * as Yup from "yup";
import {
  updateLocation,
  createLocation,
} from "reduxStore/actions/locationActions";

export const useLocationForm = ({ editMode, currentLocation, setOpen }) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Location Name is required"),
    address: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    postCode: Yup.string().required("Postcode is required"),
  });

  const initialValues = {
    name: currentLocation ? currentLocation.name : "",
    address: currentLocation ? currentLocation.address : "",
    city: currentLocation ? currentLocation.city : "",
    postCode: currentLocation ? currentLocation.postCode : "",
  };

  const user = useSelector((state) => state.user);
  const organisationId = user.organisation;

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    values.organisation = organisationId;
    try {
      let response;
      if (editMode) {
        response = await dispatch(updateLocation(currentLocation._id, values));
      } else {
        response = await dispatch(createLocation(values));
      }

      if (response) {
        dispatch(
          setSnackbar({
            open: true,
            message: editMode
              ? "Location updated successfully"
              : "Location created successfully",
            severity: "success",
          })
        );
      } else {
        dispatch(
          setSnackbar({
            open: true,
            message: "An error occurred",
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        setSnackbar({
          open: true,
          message: error.message,
          severity: "error",
        })
      );
    } finally {
      setSubmitting(false);
      setOpen(false);
      resetForm();
    }
  };

  return {
    validationSchema,
    initialValues,
    handleSubmit,
  };
};
